export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14417.03a326d8.jpg";